<template>
    <VJoyAvatar
        v-for="(freelancer, index) in freelancers.slice(0, displayCount)"
        :key="index"
        class="freelancer-avatar"
        size="medium"
        :full-name="freelancer.fullName"
        :photo-url="freelancer.photoAbsoluteUrl"
    />
    <VJoyAvatar v-if="displayTotalNumber" :total-number="howManyMore" class="freelancer-avatar" />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import type {DeepReadonly} from '@malt/types-utils';
    import {VJoyAvatar} from '@maltjoy/core-vue';
    import type {ProfileSummary} from '@api';

    interface Props {
        freelancers: DeepReadonly<ProfileSummary[]>;
        displayCount?: number;
        totalCount: number;
    }

    const props = withDefaults(defineProps<Props>(), {
        displayCount: 5,
    });

    const displayTotalNumber = computed<boolean>(() => {
        return props.totalCount > 0 && props.displayCount < props.totalCount;
    });

    const howManyMore = computed<number>(() => {
        return props.totalCount - props.displayCount;
    });
</script>

<style scoped lang="scss">
    .freelancer-avatar {
        border: 2px solid white;
        &:not(:first-child) {
            margin-left: -28px;
        }
    }
</style>
